module.exports = __webpack_public_path__ + "static/image_3_thumb-9f35cd6da2106d297e64329af4ecdc58.jpg";